import { useAuthContext } from '../Context';

export default function useAuthScreenConteinerVM() {
  const { screen } = useAuthContext();
  return { screen };
}
